module.exports = __webpack_public_path__ + "static/media/booth-curtain.7a663130.svg";